var $tabs = [];
jQuery( document ).ready(function() {
    
    // Check if component is added to the page
    $section = jQuery('section.anchor-menu');
    currentAnchor = window.location.hash.substr(1);

    if( $section.length ) {
        if ($section.hasClass('type-anchors')) {
            // Scroll anchors
            jQuery(document).on("scroll", onScrollAnchorMenu);
            jQuery('.anchor-menu-container a').first().addClass('active');
            // First anchor "scroll-margin-top" css property fails on Chrome - hack fix
            if (currentAnchor && currentAnchor == jQuery('.anchor-menu-container a').first().attr("href").substring(1)) {
                setTimeout(function() {
                    window.scrollTo(0, 0);
                }, 10);
            }
            jQuery('.anchor-menu-container a').on('click', function() {
                if (jQuery(this).is(":first-of-type")) {
                    setTimeout(function() {
                        window.scrollTo(0, 0);
                    }, 10);
                }
            });
        } else if ($section.hasClass('type-tabs')) {
            // Tabs
            jQuery('.anchor-menu-container a').each(function () {
                var currLink = jQuery(this);
                var refElement = jQuery(currLink.attr("href"));
                if (refElement.length) {
                    refElement.hide();
                    $tabs.push(refElement);
                }
            });
            jQuery('.anchor-menu-container a').on('click', function () {
                currElement = jQuery(this);
                currLink = currElement.attr("href").substring(1);
                selectTab(currLink);
                return false;
            });
            // Check tab on page load
            if (currentAnchor && selectTab(currentAnchor)) { // we have an anchor in url
                setTimeout(function() {
                    window.scrollTo(0, 0);
                }, 1);
            } else { // select first tab
                jQuery('.anchor-menu-container a').first().click();
                $anchorElement = jQuery('#' + currentAnchor);
                if (currentAnchor && $anchorElement.length) {
                    location.hash = '#none';
                    setTimeout(function() {
                        location.hash = '#' + currentAnchor;
                    }, 1);
                }
            }
        }
    }

    // Select current anchor menu element based on viewport scroll
    function onScrollAnchorMenu(event){
        var scrollPos = jQuery(document).scrollTop() + 180;
        jQuery('.anchor-menu-container a').each(function () {
            var currLink = jQuery(this);
            var refElement = jQuery(currLink.attr("href"));
            if (refElement.length)
            if (refElement.length && (
                    (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) || // section in viewport
                    (refElement.is(":first-of-type") && refElement.position().top >= scrollPos) // scroll above first section => first section remains active
            )) {
                jQuery('.anchor-menu-container a').removeClass("active");
                currLink.addClass("active");
            } else {
                currLink.removeClass("active");
            }
        });
    }

    // Select menu tab by anchor (hash)
    function selectTab(hash) {
        found = false;
        jQuery('.anchor-menu-container a').removeClass('active');
        jQuery.each($tabs, function() {
            if (hash == jQuery(this).attr("id")) {
                found = true;
                jQuery(this).show();
                jQuery('.anchor-menu-container a[href="#' + hash + '"]').addClass('active');
                if (jQuery('.anchor-menu').hasClass('sticky') && jQuery(document).scrollTop() > 0) {
                    toggleSmoothScroll(false);
                    location.hash = '#' + hash;
                    setTimeout(function() {
                        toggleSmoothScroll(true);
                    },100);
                        
                }
            } else {
                jQuery(this).hide();
            }
        });
        if (!found) {
            return false;
        }
        return true;
    }

});

function toggleSmoothScroll(state) {
    jQuery('html').css('scroll-behavior', (state ? 'smooth' : 'auto'));
}